import { Container } from "react-bootstrap";
import { useParams } from 'react-router';
import fi_translation from 'locale/fi';
import { Spin } from "antd";
import {useState } from 'react';
import { convertToObjectKeyString } from "Utils/Common";
import LoanOfferComparisonPdf from "components/generate-pdf/LoanOfferComparisonPdf";
var htmlPdfClient = require("html-pdf-client")

const Locale: any = {
    fi: fi_translation,
};

function LoanOfferComparisonPdfPage(props: any) {

    const [loading,setLoading] = useState<any>(false)
    const generatePDF =async () => {
        var element:any = document.getElementById('report');
        var opt = {
            margin:        0.1,
            filename:     'loan-offer-comparison.pdf',
            image:        { type: 'jpeg', quality: 3 },
            html2canvas:  { scale: 3.6 },
            jsPDF:        { unit: 'pt', format: 'A4', orientation: 'landscape',compressPDF: true },
            pagebreak:    { mode: 'avoid-all', before: '.page-break' }
        };
        // New Promise-based usage:
        setLoading(true);
        await htmlPdfClient().set(opt).from(element).save();
        setLoading(false);
    }

    const TranslateString = (string:any) => {
        let key:any = convertToObjectKeyString(string);
        // console.log('translate',"\""+key+"\": \""+string+"\",")
        let value = Locale['fi'][key];
        // return value;
        return (value===key) ? string : value;
    };

    return (
        <>
            <Spin spinning={loading} >
                <Container fluid className="py-2 cu-text-small">
                    <div  id="report">
                        <LoanOfferComparisonPdf {...useParams()} TranslateString={TranslateString}/>
                    </div>
                </Container>
            </Spin>
            <button onClick={generatePDF} type="button" className="btn btn-sm cu-btn-green my-3 rounded-0"  disabled={loading}>{loading?TranslateString("Please Wait"):TranslateString("Export PDF")}</button>
        </>    
    );
}

export default LoanOfferComparisonPdfPage;